import {
    ROLE
  } from "redux/actions/role/roleTypes";
  
  const initState =  localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user"))  : {},

  
roleReducer = (state = initState, { type, payload }) => {

    switch (type) {
      case ROLE:
        return {
          ...state,...payload
        };
  
      default:
        return state;
    }
  };
  
  export default roleReducer;
  